<template>
  <tr>
    <td>
      <!-- <button @click="verFotos(modelValue.numero_contenedor)" class="btn-primary btn--text" type="button"><i class="fa fa-picture-o"></i><span>Fotos</span></button> -->
      <button @click="verLogs" class="btn-secondary btn--text" type="button">
        <i class="fa fa-file"></i>
        <span>Logs</span>
      </button>
      <button
        v-show="modelValue.eir_in !== null && modelValue.eir_in !== ''"
        @click="verEir"
        class="btn-info btn--text"
        type="button"
      >
        <i class="fa fa-eye"></i>
        <span>Caja</span>
      </button>
      <button
        v-show="modelValue.eir_maquina_in !== null && modelValue.eir_maquina_in !== ''"
        @click="verEirMaquina"
        class="btn-success btn--text"
        type="button"
      >
        <i class="fa fa-eye"></i>
        <span>Máquina</span>
      </button>
      <modal scrollable :name="'notificacion' + $vnode.key" width="50%" height="auto">
        <notificacion-proceso
          :id="$vnode.key"
          @motivo="motivo"
          @cancelar="cancelarMotivo"
          :number="modelValue.numero_contenedor"
        ></notificacion-proceso>
      </modal>
      <modal scrollable :name="'logs' + $vnode.key" width="75%" height="auto">
        <reporte-logs
          @cerrar="$modal.hide('logs' + $vnode.key)"
          :number="modelValue.numero_contenedor"
        ></reporte-logs>
      </modal>
    </td>
    <td>
      <button
        type="button"
        class="btn-info btn--text"
        @click="verFotos(modelValue.numero_contenedor)"
      >{{ modelValue.numero_contenedor }}</button>
    </td>
    <td>{{ modelValue.fecha }}</td>
    <td>{{ modelValue.cliente }}</td>
    <td>{{ modelValue.patio }}</td>
    <td>{{ modelValue.usuario_garita }}</td>
    <td>{{ modelValue.usuarioFinalizacion }}</td>
    <td>{{ modelValue.date_i_b }}</td>
    <td>{{ modelValue.date_i_m }}</td>
    <td>{{ modelValue.fecha_e_caja }}</td>
    <td>{{ modelValue.fecha_e_maquina }}</td>
    <td>{{ modelValue.eir_caja_in }}</td>
    <td>{{ modelValue.eir_maquina_in }}</td>
    <td v-if="tipoEstado !== 'D' && tipoEstado !== 'G' && tipoEstado !== 'S'">
      <label :for="'inspeccionFinalizadaC' + $vnode.key">
        <input
          :disabled="bloqueadoCaja || !modelValue.inspeccion_finalizada_c"
          @change="desbloquearInspeccion('C')"
          v-model="modelValue.inspeccion_finalizada_c"
          type="checkbox"
          :id="'inspeccionFinalizadaC' + $vnode.key"
        />
        <span></span>
      </label>
    </td>
    <td v-if="tipoEstado !== 'D' && tipoEstado !== 'G' && tipoEstado !== 'S'">
      <label :for="'inspeccionFinalizadaM' + $vnode.key">
        <input
          :disabled="bloqueadoMaquina || !modelValue.inspeccion_finalizada_m"
          @change="desbloquearInspeccion('M')"
          v-model="modelValue.inspeccion_finalizada_m"
          type="checkbox"
          :id="'inspeccionFinalizadaM' + $vnode.key"
        />
        <span></span>
      </label>
    </td>
    <td v-if="tipoEstado === 'D' || tipoEstado === 'G' || tipoEstado === 'S'">
      <label :for="'digitacionFinalizada' + $vnode.key">
        <input
          :disabled="modelValue.bloqueadoMaquina || !modelValue.inspeccion_finalizada_c"
          @change="desbloquearInspeccion(tipoEstado)"
          v-model="modelValue.inspeccion_finalizada_c"
          type="checkbox"
          :id="'digitacionFinalizada' + $vnode.key"
        />
        <span></span>
      </label>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    inspeccion: {
      type: Object,
      required: false,
      default: function() {
        return {
          numero_contenedor: "",
          fecha: "",
          eir_caja_in: "",
          eir_maquina_in: "",
          inspeccion_finalizada_m: false,
          inspeccion_finalizada_c: false,
          cliente: "",
          patio: "",
          inspector: "",
          usuarioFinalizacion: "",
          usuario_garita: ""
        };
      }
    },
    preguntaText: {
      type: String,
      required: false,
      default: "¿Deseas desbloquear este registro?"
    },
    confirmarText: {
      type: String,
      required: false,
      default: "Confirmar"
    },
    cancelarText: {
      type: String,
      required: false,
      default: "Cancelar"
    },
    errorText: {
      type: String,
      required: false,
      default: "Error"
    },
    errorMessageText: {
      type: String,
      required: false,
      default: "Hubo un error, intente nuevamente."
    },
    realizadoText: {
      type: String,
      required: false,
      default: "El registro fue desbloqueado exitósamente."
    },
    avisoText: {
      type: String,
      required: false,
      default: "El registro fue desbloqueado exitósamente."
    },
    estado: {
      type: String,
      required: false,
      default: "I"
    },
    bloqueadoMaquina: {
      type: Boolean,
      required: false,
      default: false
    },
    bloqueadoCaja: {
      type: Boolean,
      required: false,
      default: false
    },
    tipoEstado: {
      type: String,
      required: false,
      default: ""
    }
  },
  data: function() {
    return {
      modelValue: this.inspeccion,
      url: url,
      currentTipo: ""
    };
  },
  methods: {
    verFotos: function(number) {
      window.open(
        url + "/contenedores/" + this.modelValue.numero_contenedor,
        "_blank"
      );
    },
    verLogs: function() {
      this.$modal.show("logs" + this.$vnode.key);
    },
    motivo: function(motivo) {
      let tipo = this.currentTipo;
      let that = this;
      axios
        .post(that.url + "/inspecciones/" + that.modelValue.numero_contenedor, {
          _method: "DELETE",
          tipo: tipo,
          estado: that.estado,
          motivo: motivo
        })
        .then(function(response) {
          if (response.data.sent)
            swal({
              text: that.$t("message.accionRealizada"),
              focusConfirm: true,
              title: that.$t("message.aviso"),
              type: "success"
            });
          else
            swal(
              "Desbloqueo exitoso, pero no pudo enviarse correo electrónico.",
              "Realizado",
              "warning"
            );
          that.$modal.hide("notificacion" + that.$vnode.key);
        })
        .catch(function() {
          swal(that.$t("message.errorText"), that.$t("message.error"), "error");
          if (tipo === "M")
            that.modelValue.inspeccion_finalizada_m = !that.modelValue
              .inspeccion_finalizada_m;
          else
            that.modelValue.inspeccion_finalizada_c = !that.modelValue
              .inspeccion_finalizada_c;
        });
    },
    cancelarMotivo: function() {
      let that = this;
      this.$modal.hide("notificacion" + this.$vnode.key);
      let tipo = this.currentTipo;
      if (tipo === "M")
        that.modelValue.inspeccion_finalizada_m = !that.modelValue
          .inspeccion_finalizada_m;
      else
        that.modelValue.inspeccion_finalizada_c = !that.modelValue
          .inspeccion_finalizada_c;
    },
    solicitarMotivo: function() {
      this.$modal.show("notificacion" + this.$vnode.key);
    },
    desbloquearInspeccion: function(tipo) {
      this.currentTipo = tipo;
      let that = this;
      if (
        (!this.modelValue.inspeccion_finalizada_c && tipo === "C") ||
        (!this.modelValue.inspeccion_finalizada_m && tipo === "M") ||
        (!this.modelValue.inspeccion_finalizada_c && tipo === "G") ||
        (!this.modelValue.inspeccion_finalizada_c && tipo === "S")
      ) {
        swal({
          title: that.$t("message.deseasDesbloquear"),
          type: "question",
          showCancelButton: true,
          confirmButtonText: that.$t("message.confirmar"),
          cancelButtonText: that.$t("message.cancelar"),
          focusConfirm: true
        }).then(result => {
          if (result.value) that.solicitarMotivo();
          else {
            if (tipo === "M")
              that.modelValue.inspeccion_finalizada_m = !that.modelValue
                .inspeccion_finalizada_m;
            else
              that.modelValue.inspeccion_finalizada_c = !that.modelValue
                .inspeccion_finalizada_c;
          }
        });
      }
    },
    verEir: function() {
      window.open(
        this.url +
          "/eir?eir=" +
          this.modelValue.eir_caja_in +
          "&tipo=in&tipo_eir=C",
        "_blank"
      );
    },
    verEirMaquina: function() {
      window.open(
        this.url +
          "/eir?eir=" +
          this.modelValue.eir_maquina_in +
          "&tipo=in&tipo_eir=M",
        "_blank"
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/inspeccion/ItemInspeccion.vue